import apiClient from "./apiClient";

const endpoints = {
  login: "/admin/auth/login",
  interests: "/admin/interest",
};

export async function adminLogin(payload, { signal } = {}) {
  console.log("🔗 Calling API:", endpoints.login, "with", payload);
  const res = await apiClient.post(endpoints.login, payload, { signal });
  console.log("📩 API Response:", res?.data);
  return res?.data?.data?.token || "";
}

export async function getAllInterests({ signal } = {}) {
  console.log("🔗 Fetching Interests API:", endpoints.interests);
  const res = await apiClient.get(endpoints.interests, { signal });
  console.log("📩 Interests Response:", res.data);
  return res.data;
}
